import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { IFetchTransactions } from '../interfaces';
import { UseFetchTransactionsProps } from './useFetchTransactions';

export const useFetchExtrenalTransactions = () => {
  const { customerId } = useStore((state) => state.user);
  const selectedSyncedCard = useStore((state) => state.selectedSyncedCard);
  return useMutation('useFetchTransactionsFacelift', async ({ queryParamsString }: UseFetchTransactionsProps) => {
    if (!selectedSyncedCard) {
      // this prevents errors when selectedSyncedCard is null and avoids unnecessary API calls
      return Promise.reject(new Error('No selected synced card'));
    }
    const { data } = await httpService.get(
      `${BASE_URL}/api/v1/user/${customerId}/externalAccount/${selectedSyncedCard?.externalId}/transactions?${queryParamsString}`,
    );
    return data as IFetchTransactions;
  });
};
